import { Heading, Spacing } from '@big-red-group/storefront-common-ui'
import { Content, Wrapper } from './ContentBlock.styles'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import { convertToReactCSS } from '@/helpers/BlogHelper'

const ContentBlock: React.FC<{ title?: string; content: string; style?: string; rawHTML?: Boolean }> = ({
  title,
  content,
  style,
  rawHTML = false,
}) => {
  return (
    <>
      <Wrapper>
        {title && (
          <Heading size={'M'} dataTestId="content-block-heading">
            {title}
          </Heading>
        )}
        {rawHTML ? (
          <Content
            dangerouslySetInnerHTML={{ __html: content }}
            style={style ? convertToReactCSS(style) : {}}
          ></Content>
        ) : (
          <Content style={style ? convertToReactCSS(style) : {}}>
            <ReactMarkdown rehypePlugins={[rehypeRaw]}>{content}</ReactMarkdown>
          </Content>
        )}
      </Wrapper>
      <Spacing size="XXXL" />
    </>
  )
}

export default ContentBlock
